module.exports = __webpack_public_path__ + "img/TECNOLOGIA-XL7-2.2ac4b5e4.jpg";